var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Camera  Off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Camera",
    transform: "translate(-12.000000, -13.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Camera--Off",
    transform: "translate(12.194021, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-off",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.767636115,3.3780254 L14.6429448,17.2544638 C14.4577375,17.8523073 13.9004455,18.2865585 13.2417284,18.2865585 L1.27851003,18.2865585 C0.468492399,18.2865585 -0.188156634,17.6299112 -0.188156634,16.8198958 L-0.188156634,4.75326233 C-0.188156634,4.12291389 0.209499891,3.58544286 0.767636115,3.3780254 Z M23.7642828,6.48149495 C23.7958603,6.60245347 23.8118434,6.7269529 23.8118434,6.85196529 L23.8118434,14.7211928 C23.8118434,15.5312083 23.1551943,16.1878554 22.3451767,16.1878554 C22.220164,16.1878554 22.0956642,16.1718724 21.9747054,16.140295 L20.3851767,15.725191 L16.36251,11.7025354 L16.3635675,8.03063147 C16.3635675,7.36329902 16.8140686,6.78009353 17.4597628,6.61152929 L21.9747054,5.43286311 C22.758456,5.22825798 23.5596771,5.69774645 23.7642828,6.48149495 Z M13.2417284,3.28655848 C14.051746,3.28655848 14.7083951,3.94324693 14.7083951,4.75326233 L14.7078434,10.0478732 L7.94784337,3.28655848 L13.2417284,3.28655848 Z",
    id: "Icon-Color",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5406526,20.4535622 L2.35241729,0.265326799 C1.99864823,-0.0884422663 1.42507524,-0.0884422663 1.07130618,0.265326799 C0.717537118,0.619095864 0.717537118,1.19266885 1.07130618,1.54643791 L21.2595415,21.7346733 C21.6133105,22.0884422 22.1868835,22.0884422 22.5406526,21.7346733 C22.8944217,21.3809042 22.8944217,20.8073312 22.5406526,20.4535622 Z",
    id: "Path-12",
    fill: "#FF313D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamOff);
export default __webpack_public_path__ + "static/media/cam_off.dbd53683e6c1be6abcabe64345b371db.svg";
export { ForwardRef as ReactComponent };